/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateDocumentTypeRequest } from '../models/create-document-type-request';
import { DocumentTypeResponse } from '../models/document-type-response';
import { GenericResponse } from '../models/generic-response';
import { GetDocumentTypeResponse } from '../models/get-document-type-response';
import { UpdateDocumentTypeRequest } from '../models/update-document-type-request';

/**
 * document type apis
 */
@Injectable({ providedIn: 'root' })
export class DocumentTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDocumentTypes()` */
  static readonly GetDocumentTypesPath = '/api/v1/document-types';

  /**
   * get all document types.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDocumentTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocumentTypes$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields.
       * - name
       * - description
       */
      documentType?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetDocumentTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DocumentTypeService.GetDocumentTypesPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('documentType', params.documentType, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetDocumentTypeResponse>;
        })
      );
  }

  /**
   * get all document types.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDocumentTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocumentTypes(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields.
       * - name
       * - description
       */
      documentType?: string;
    },
    context?: HttpContext
  ): Observable<GetDocumentTypeResponse> {
    return this.getDocumentTypes$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetDocumentTypeResponse>
        ): GetDocumentTypeResponse => r.body
      )
    );
  }

  /** Path part for operation `createNewDocumentType()` */
  static readonly CreateNewDocumentTypePath = '/api/v1/document-types';

  /**
   * create new Document Type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createNewDocumentType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createNewDocumentType$Response(
    params: {
      body: CreateDocumentTypeRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<DocumentTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DocumentTypeService.CreateNewDocumentTypePath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<DocumentTypeResponse>;
        })
      );
  }

  /**
   * create new Document Type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createNewDocumentType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createNewDocumentType(
    params: {
      body: CreateDocumentTypeRequest;
    },
    context?: HttpContext
  ): Observable<DocumentTypeResponse> {
    return this.createNewDocumentType$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<DocumentTypeResponse>): DocumentTypeResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `getDocumentTypeById()` */
  static readonly GetDocumentTypeByIdPath = '/api/v1/document-types/{id}';

  /**
   * get Document Type by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDocumentTypeById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocumentTypeById$Response(
    params: {
      /**
       * The Document Type id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<DocumentTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DocumentTypeService.GetDocumentTypeByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<DocumentTypeResponse>;
        })
      );
  }

  /**
   * get Document Type by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDocumentTypeById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocumentTypeById(
    params: {
      /**
       * The Document Type id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<DocumentTypeResponse> {
    return this.getDocumentTypeById$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<DocumentTypeResponse>): DocumentTypeResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `disableDocumentTypeById()` */
  static readonly DisableDocumentTypeByIdPath = '/api/v1/document-types/{id}';

  /**
   * disable Document Type by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disableDocumentTypeById()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableDocumentTypeById$Response(
    params: {
      /**
       * The Document Type id that needs to be soft deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DocumentTypeService.DisableDocumentTypeByIdPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * disable Document Type by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disableDocumentTypeById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableDocumentTypeById(
    params: {
      /**
       * The Document Type id that needs to be soft deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.disableDocumentTypeById$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateDocumentTypeById()` */
  static readonly UpdateDocumentTypeByIdPath = '/api/v1/document-types/{id}';

  /**
   * update Document Type by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDocumentTypeById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDocumentTypeById$Response(
    params: {
      /**
       * The Document Type id that needs to be updated
       */
      id: number;
      body: UpdateDocumentTypeRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<DocumentTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DocumentTypeService.UpdateDocumentTypeByIdPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<DocumentTypeResponse>;
        })
      );
  }

  /**
   * update Document Type by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDocumentTypeById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDocumentTypeById(
    params: {
      /**
       * The Document Type id that needs to be updated
       */
      id: number;
      body: UpdateDocumentTypeRequest;
    },
    context?: HttpContext
  ): Observable<DocumentTypeResponse> {
    return this.updateDocumentTypeById$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<DocumentTypeResponse>): DocumentTypeResponse =>
          r.body
      )
    );
  }
}
